import { useEffect } from 'react';

import { extractThumbnailsSource } from './extractThumbnailsSource';
import { useMediaPlayer } from '../../../MediaPlayerProvider';
import { useMediaSourceDetails } from '../../../useMediaSourceDetails';

export const Thumbnails: React.FC = () => {
  const { player } = useMediaPlayer();
  const mediaDetails = useMediaSourceDetails();

  useEffect(() => {
    if (player !== null) {
      player.ready(() => {
        const thumbnailSource = extractThumbnailsSource(mediaDetails);
        if (thumbnailSource !== null) {
          player.addRemoteTextTrack(thumbnailSource, false);
        }
      });
    }
  }, [mediaDetails, player]);

  return null;
};
